import { chartKeys } from 'utils/constant';

const return_risk_ratio_hit_ratio = {
  chartTitle: 'Return-Risk-Ratio & Hit Rate',
  chartKey: chartKeys.RETURN_RISK_RATIO_HIT_RATIO,
}

export default return_risk_ratio_hit_ratio;